// extracted by mini-css-extract-plugin
export default {"hideTooltip":"H_-z","fadeIn":"I_-z","delay":"J_-z","recommendedSizeTooltip":"K_-z"};